import { render, staticRenderFns } from "./BehindTheScene.vue?vue&type=template&id=c0f34fea&scoped=true&"
import script from "./BehindTheScene.vue?vue&type=script&lang=js&"
export * from "./BehindTheScene.vue?vue&type=script&lang=js&"
import style0 from "./BehindTheScene.vue?vue&type=style&index=0&id=c0f34fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f34fea",
  null
  
)

export default component.exports